<template>
	<div class="h-panel-body padding font-bold">
		<div class="h-panel-bar"><span class="h-panel-title">收支类型</span></div>

        <div class="div_tabs">
            <a-tabs v-model:activeKey="activeKey" type="card">
                
                <a-tab-pane key="1" tab="收入">  
                    <div class="div_tab_query">
                        <button class="h-btn h-btn-blue" @click="showDrawer(undefined,1)">新增</button> 
                        <button class="h-btn " @click="loadList()">刷新</button> 
                     </div>
                    
                     <div class="div_tabs_table">
                        <Table :datas="tab1Data" :height="650" :border="true">
                            <TableItem title="序号"  :width="80"><template slot-scope="{index}">{{index+1}}</template></TableItem>
                            <TableItem title="编码" prop="code" :width="100" />
                            <TableItem title="名称" prop="name" align="center" :width="200" /> 
                            <TableItem title="默认关联科目" prop="subjectName" align="center" :width="200" />
                            <TableItem title="备注" prop="remark" align="center" :width="200" />
                            <TableItem title="操作" :width="100" align="center">
                                <template #default="{ data }">
                                    <span style="color:#2d7bf4; cursor: pointer;" @click="showDrawerEdit(data)">编辑</span> &nbsp;&nbsp;
                                    <span style="color:#2d7bf4; cursor: pointer;" @click="del(data.id)">删除</span>
                                </template>
                            </TableItem>
                            <template #empty>
                                自定义提醒：暂时无数据
                            </template>
                        </Table>
                     </div>
                </a-tab-pane>
               
                <a-tab-pane key="2" tab="支出"  >  
                    <div class="div_tab_query">
                        <button class="h-btn h-btn-blue" @click="showDrawer(undefined,2)">新增</button> 
                        <button class="h-btn " @click="loadList2()">刷新</button> 
                     </div>
                     <div class="div_tabs_table">
                        <Table :datas="tab2Data" :height="650" :border="true">
                            <TableItem title="序号"  :width="80"><template slot-scope="{index}">{{index+1}}</template></TableItem>
                            <TableItem title="编码" prop="code" :width="100" />
                            <TableItem title="名称" prop="name" align="center" :width="200" /> 
                            <TableItem title="默认关联科目" prop="subjectName" align="center" :width="200" />
                            <TableItem title="备注" prop="remark" align="center" :width="200" />
                             <TableItem title="操作" :width="100" align="center">
                                <template #default="{ data }">
                                    <span style="color:#2d7bf4; cursor: pointer;" @click="showDrawerEdit(data)">编辑</span> &nbsp;&nbsp;
                                    <span style="color:#2d7bf4; cursor: pointer;" @click="del(data.id)">删除</span>
                                </template>
                            </TableItem>
                            <template #empty>
                                自定义提醒：暂时无数据
                            </template>
                        </Table>
                     </div>
                </a-tab-pane>
            </a-tabs>
            <a-drawer title="编辑设置" width="50%" :closable="false" :visible="visible" @close="onClose">

			<div class="fiveeditbox">
				<ul>
					<li>
						<p>*方向：</p>
                        <a-radio-group v-model:value="showdata.type" button-style="solid" >
								<a-radio-button :value="1">收入</a-radio-button>
								<a-radio-button :value="2">支出</a-radio-button> 
							</a-radio-group>
					</li>
                    <li>
						<p>*编码：</p><a-input placeholder="编码" :value="showdata.code" v-model="showdata.code" />
					</li>
					<li>
						<p>*名称：</p>
                        <a-input placeholder="名称" :value="showdata.name" v-model="showdata.name" />
					</li>  
                     <li>
						<p>关联科目</p>
                        <a-select v-model="showdata.subjectId" :options="subjectData"  style="width:100%"
							show-search :filter-option="filterOption" :allowClear='true'></a-select>
					</li>
                    <li>
						<p>备注：</p>
                        <a-input placeholder="备注" :value="showdata.remark" v-model="showdata.remark" />
					</li> 
				</ul>
			</div>

			<div :style="{
				position: 'absolute',
				bottom: 0,
				width: '100%',
				borderTop: '1px solid #e8e8e8',
				padding: '10px 16px',
				textAlign: 'right',
				left: 0,
				background: '#fff',
				borderRadius: '0 0 4px 4px',
			}">
				<a-button style="marginRight: 8px" @click="onClose">取消</a-button>
				<a-button type="primary" @click="onSave">确定</a-button>
			</div>
		</a-drawer>

        </div> 
	</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment'
import { mapState } from 'vuex'

export default {
	name: "Salarymanage",
    watch: {  
		},
	data() {
		return {
            activeKey:"1",
			loading:false,
            locale,
            actSelectData:[],
            tab1Data:[],
            tab2Data:[],
            subjectData:[],
            visible:false,
            showdata:{},
		}
	},
	computed: {
		...mapState(['User', 'currentAccountSets']),
		date() {
			return moment(this.accountDate);
		}
	},
	created() {   
        this.subjectLoad();
		this.loadList();
        this.loadList2();
	},
	mounted() {
        
	},
	methods: { 
        loadList(){
            var accountSetsId = this.User.accountSetsId;
              
            var params ={
                accountSetsId:accountSetsId, 
                type : 1 
            };
            this.$api.cashier.trade_list(params).then(({ data }) => {  
                this.tab1Data=data; 
			})
        },
        loadList2(){
            var accountSetsId = this.User.accountSetsId;
              
            var params ={
                accountSetsId:accountSetsId, 
                type : 2 
            };
            this.$api.cashier.trade_list(params).then(({ data }) => {  
                this.tab2Data=data; 
			})
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        }, 
        subjectLoad() { 
				this.$api.setting.subject.voucherSelect({showAll: true}).then(({data}) => {
					var voucherSelect = data;	
					if(voucherSelect!=undefined && voucherSelect.length>0){
						for(var i = 0;i<voucherSelect.length;i++){
							var ops = {
								value:voucherSelect[i].id,
								label:voucherSelect[i].subjectFullName
							}
							this.subjectData.push(ops);
						}
					}
				});
			},
            showDrawer(id,type){
                if(id==undefined){
                    this.showdata={
                        type:type
                    };
                    this.visible=true;
                }
            },
            showDrawerEdit(data){
                this.showdata=data;
                this.visible=true;
            },  
            onSave(){
                //保存
                var that =this;
                this.showdata.accountSetsId = this.User.accountSetsId;
                if(this.showdata.id==undefined){
                    this.$api.cashier.trade_add(this.showdata).then(data => {
                        if (data.code == 200) {
                            if(this.showdata.type==1){
                                that.loadList();
                            }else{
                                that.loadList2();
                            }
                            this.$message.success('保存成功');
                            this.visible = false;
                        } else {
                            this.$message.error('保存失败');
                        }
                    })
                }else{
                    this.$api.cashier.trade_edit(this.showdata).then(data => {
                        if (data.code == 200) {
                            if(this.showdata.type==1){
                                that.loadList();
                            }else{
                                that.loadList2();
                            }
                            this.$message.success('保存成功');
                            this.visible = false;
                        } else {
                            this.$message.error('保存失败');
                        }
                    })
                }
            },
            onClose(){
                this.showdata={}
                this.visible=false;
            }
		

	},
	mounted() {

	}
}
</script>


<style lang="less" scoped>
.h-row>div>div {
	padding: 8px;
	border-radius: 5px;
	text-align: center;
	font-size: 20px;
	color: #000;
}

.period {
	border-radius: 3px;
	text-align: center;
	line-height: 54px;
	border: 1px solid @primary-color;
	white-space: nowrap;
	overflow: hidden;
	box-sizing: border-box;
	height: 80px;

	&:hover {
		cursor: pointer;
		box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
	}

	.month-header {
		height: 25px;
		margin: -8px -8px 0 -8px;
	}

	&.completed {
		.month-header {
			background-color: @gray1-color !important;
			line-height: 20px;
		}

		border-color: @gray1-color;

		color: #a2a2a2;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}

	&.disable {
		opacity: 0.4;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}
}

.topselectbox {}

.topselectbox .topselect02 {
	padding-top: 15px;
	padding-left: 20px;
}

.tablebox {
	padding-left: 20px;
	padding-top: 20px;
}

.fiveeditbox {
	width: 800px;
	margin: 0 auto;
}

.fiveeditbox ul li {}

.fiveeditbox ul li p {
	font-size: 15px;
	padding-bottom: 5px;
	padding-top: 10px;
}
.fiveeditbox table tr td span {
	font-size: 15px; 
    line-height: 31px;
    display:inline-block;
    width:90px;
}
.fiveeditbox table tr td input {
	width:70%; 
}
.fiveeditbox table tr{
    height:70px;
}
.yemabox {
	padding-top: 50px;
	padding-bottom: 30px;
}
.yema{ text-align:center; padding-top:30px;}
.div_tabs{margin-top:10px;}
.div_tab_query{
    margin-left:25px;
}
.div_tabs_table{margin-top:15px;}
</style>
